import { AxiosPromise, AxiosRequestConfig } from "axios";
import { cookieAuthorizedApi, BaseApi, AuthProvider } from "ecom-teams-apps-core";

export interface AuthorizationService {
    authorize: (username?: string, password?: string) => AxiosPromise;
    teamsAuthorize: () => AxiosPromise;
}

export class DefaultAuthorizationService implements AuthorizationService {
    private authorizeUrl: string = "/user/login";
    private teamsAuthorizeUrl: string = "/public/auth";

    constructor(private cookieAuthorizedApi: BaseApi) {}

    authorize(username?: string, password?: string): AxiosPromise {
        return this.cookieAuthorizedApi.post(this.authorizeUrl, {
            username: username,
            password: password,
        });
    }

    teamsAuthorize(): AxiosPromise {
        this.cookieAuthorizedApi.interceptors.request.use(async (config: AxiosRequestConfig) => {
            const token = await AuthProvider.getAuthToken();

            return {
                ...config,
                headers: {
                    ...config.headers,
                    Authorization: token,
                },
            };
        });

        return this.cookieAuthorizedApi.post(this.teamsAuthorizeUrl, {});
    }
}

export class AuthorizationServiceWithResponse implements AuthorizationService {
    _response: any = {
        data: this.response,
    };

    constructor(private response: any) {}

    authorize(username?: string, password?: string) {
        return Promise.resolve(this._response);
    }

    teamsAuthorize() {
        return Promise.resolve(this._response);
    }
}

export class AuthorizationServiceWithError implements AuthorizationService {
    _response: any = {
        data: this.response,
    };

    constructor(private response: any) {}

    authorize(username?: string, password?: string) {
        return Promise.reject(this._response);
    }

    teamsAuthorize() {
        return Promise.reject(this._response);
    }
}

export default new DefaultAuthorizationService(cookieAuthorizedApi);
